import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BrandingContext = createContext(null);

export const useBranding = () => {
  const context = useContext(BrandingContext);
  if (!context) throw new Error("useBranding must be used within BrandingProvider");
  return context;
};

export const BrandingProvider = ({ children }) => {
  const [appName, setAppName] = useState("BizilGO");
  const [logoBase64, setLogoBase64] = useState("/logo.png"); // Default BizilGO logo
  const [loading, setLoading] = useState(true);

  const fetchBranding = async () => {
    try {
      const res = await axios.get(`${API}/branding`);
      if (res.data.app_name) setAppName(res.data.app_name);
      if (res.data.logo_base64) setLogoBase64(res.data.logo_base64);
    } catch (err) {
      console.error("Failed to fetch branding:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBranding();
  }, []);

  const updateBranding = async (newAppName, newLogo) => {
    try {
      const payload = {};
      if (newAppName !== undefined) payload.app_name = newAppName;
      if (newLogo !== undefined) payload.logo_base64 = newLogo;
      
      const res = await axios.put(`${API}/admin/branding`, payload);
      
      if (res.data.branding) {
        if (res.data.branding.app_name) setAppName(res.data.branding.app_name);
        setLogoBase64(res.data.branding.logo_base64 || null);
      }
      
      return true;
    } catch (err) {
      console.error("Failed to update branding:", err);
      throw err;
    }
  };

  const refreshBranding = () => fetchBranding();

  return (
    <BrandingContext.Provider value={{ 
      appName, 
      logoBase64, 
      loading, 
      updateBranding, 
      refreshBranding 
    }}>
      {children}
    </BrandingContext.Provider>
  );
};

export default BrandingContext;
